import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import { CloudFunctionResponse } from "@fixeduy/restaurantestypes";

const eliminarSector = async (
  data: string
): Promise<CloudFunctionResponse> => {

  const run = httpsCallable<any, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );

  const result = await run({
    func: "eliminarSector",
    params: data
  } as any);

  return result.data;
};

export { eliminarSector };

